import { comluxgroup } from '@luxuryescapes/contract-data-event-schemas'
import { getCategoryAndProductId } from 'analytics/snowplow/helpers/itemCategorisation'
import { getExperienceLocations } from './itemContextHelpers'

function getExperienceOrderItems(state: App.State, orderItems: App.OrderExperienceItem[], order: App.Order) {
  if (!orderItems?.length) {
    return []
  }
  const items = orderItems?.reduce((items, orderItem) => {
    const fullOffer = state.experience.experiences[orderItem?.experienceId]
    const { categoryId, productId } = getCategoryAndProductId(fullOffer.parentType, fullOffer)
    const locations = getExperienceLocations(fullOffer.location.name)
    const destinationCity = locations.destinationCity || undefined
    const originCity = locations.originCity || undefined
    const destinationCountry = locations.destinationCountry || undefined
    const originCountry = locations.originCountry || undefined

    const orderConfirmationItem = comluxgroup.createItem_1_1_0(
      {
        offerId: orderItem.experienceId,
        categoryId,
        productId,
        duration: 1,
        travelStart: orderItem.date,
        travelEnd: orderItem.date,
        price: orderItem.total,
        offerLeadPrice: fullOffer.price,
        offerLeadDuration: '1',
        offerLeadUnit: fullOffer.ticketUnitLabel,
        currency: order.currencyCode,
        destinationCity,
        destinationCountry,
        originCity,
        originCountry,
        itemId: orderItem.id,
        bookingNumber: order.number,
        orderId: order.id,
      },
    )
    return [...items, orderConfirmationItem]
  }, [])
  return items
}

export default getExperienceOrderItems
